export const formatThousands = (s: string) => {
  const [sign, digits] = s.startsWith("-") ? ["-", s.slice(1)] : ["", s];
  return sign + digits.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
